/* eslint-disable no-undef */
import React from 'react'
import { connect } from 'react-redux';
import _ from "underscore";
import Layout from '../../Components/Layout'
import InfoActionPage from "../../Components/InfoActionPage";
import SettingsLayout from './SettingsLayout'
import { ValidatedInputField } from "../../Components/Forms";
import { getIcon } from '../../Components/Functions';
import { closePanel, openPanel } from '../../Redux/Panels/RightPanel/actions';
import { loggedUser } from '../../Constants/menus';
import { FormContent } from '../../Components/FormContent';

const structure = loggedUser?.role  === "SPECIALIST" ? [
	{
		title: "Basic Info",
		description: "Enter personal information and login details.",
		sectionClass: "mt-5 pt-5 border-top top-border",
		fields: [
			{
				name: "first_name",
				label: "First name",
				type: "photo"
			},
			{
				name: "title",
				label: "Title",
				icon: "briefcase",
				width: 12
			},
			{
				name: "first_name",
				label: "First name",
				icon: "user",
				width: 6
			},
			{
				name: "last_name",
				label: "Last name",
				icon: "user",
				width: 6
			},
			{
				name: "email",
				label: "Email",
				icon: "mail",
				// readOnly: true,
				width: 12
			},
			{
				name: "phone",
				label: "Phone",
				icon: "phone",
				width: 12
			},
			{
				name: "gender",
				label: "Gender",
				icon: "droplet",
				width: 12,
				type: "select",
				options: ["MALE", "FEMALE"],
			},
		]
	},
	{
		title: "Address Information",
		description: "Select location and address.",
		sectionClass: "mt-5 pt-5 border-top top-border w-100",
		fields: [
			{
				name: "background_image",
				label: "State/Province",
				type: "location"
			}
		]
	},
	
	{
		title: "Public Profile",
		description: "Enter your personal information.",
		sectionClass: "mt-5 pt-5 border-top top-border",
		fields: [
			{
				name: "background_image",
				label: "Background Image",
				type: "background_image"
			},
			{
				name: "header_title",
				label: "Header title",
				icon: "feather",
				width: 12
			},
			{
				name: "about",
				label: "About me",
				icon: "user",
				width: 12,
				type: "textarea"
			}
		]
	},
	{
		title: "Charges & Rating",
		description: "What is your rate? Let patients know.",
		sectionClass: "mt-5 pt-5 border-top top-border",
		fields: [
			{
				name: "consultation_fee",
				label: "Consultation Fee",
				icon: "credit-card",
				width: 12
			},
			{
				name: "consultation_fee_duration",
				label: "Duration (in minutes)",
				icon: "clock",
				width: 12
			}
		]
	},
	{
		title: "Mode of Communication",
		description: "Let patients know how they can reach you",
		sectionClass: "mt-5 pt-5 border-top top-border",
		fields: [
			{
				type: "checkbox-image",
				items: [
					{
						name: "Local Phone",
						key: "phone_enabled",
						description: "Enable local phone calling with patients",
						icon: "phone",
					},
					{
						name: "Email",
						key: "email_enabled",
						description: "Enable email communications with patients",
						icon: "mail",
					},
					{
						name: "Whatsapp",
						key: "whatsapp_enabled",
						description: "Enable whatsapp communication with patients",
						icon: "message-circle",
					},
					{
						name: "Zoom Meeting",
						key: "zoom_enabled",
						description: "Use zoom for video meeting ",
						icon: "video",
					},
					{
						name: "Google Meet",
						key: "google_meet_enabled",
						description: "Use google meet for video meeting",
						icon: "plus",
					},
					
				]
			},
		]
	},
	{
		title: "Extra Options",
		description: "Check out your extra options for your patient",
		sectionClass: "mt-5 pt-5 border-top top-border",
		fields: [
			{
				type: "checkbox-image",
				items: [
					{
						name: "Online Consultation",
						key: "online_consult",
						description: "Enable if you offer online consultation.",
						icon: "layers",
					},
					{
						name: "Home Service",
						key: "home_service",
						description: "Enable if you offer home services.",
						icon: "home",
					},
					{
						name: "Free Consultation",
						key: "free_consultation",
						description: "Enable if you also offer free consultation.",
						icon: "credit-card",
					}
					
				]
			},
		]
	},
	{
		title: "Verification Documents",
		description: "Verify your account by uploading your medical certificate and valid ID",
		sectionClass: "mt-5 pt-5 border-top top-border w-100",
		fields: [
			{
				name: "background_image",
				label: "Upload Documents",
				type: "verification-documents"
			}
		]
	}
] :  [
	{
		title: "Basic Info",
		description: "Enter personal information and login details.",
		sectionClass: "mt-5 pt-5 border-top top-border",
		fields: [
			{
				name: "first_name",
				label: "First name",
				type: "photo"
			},
			{
				name: "first_name",
				label: "First name",
				icon: "user",
				width: 6
			},
			{
				name: "last_name",
				label: "Last name",
				icon: "user",
				width: 6
			},
			{
				name: "email",
				label: "Email",
				icon: "mail",
				readOnly: true,
				width: 12
			},
			{
				name: "phone",
				label: "Phone",
				icon: "phone",
				width: 12
			},
			{
				name: "gender",
				label: "Gender",
				icon: "droplet",
				width: 12,
				type: "select",
				options: ["MALE", "FEMALE"],
			},
		]
	},
	{
		title: "Address Information",
		description: "Select location and address.",
		sectionClass: "mt-5 pt-5 border-top top-border w-100",
		fields: [
			{
				name: "background_image",
				label: "State/Province",
				type: "location"
			}
		]
	},
]

const AccountProfile = (props) => {
	let PROFILE = props?.userData || props?.user?.user || {};
	
	const [OLD_DATA] = React.useState(PROFILE);
	const [DATA, setDATA] = React.useState(PROFILE);
	const [profileMessage, setProfileMessage] = React.useState(defaultMsg);
	const [view, setView] = React.useState(0);
	const updateProfile = (d) => {
		setDATA({...DATA, ...d})
	}
	React.useEffect(() => {
		
		delete DATA.category;
		delete DATA.image;
		delete DATA.background_image;
		if (DATA.role == 'PATIENT'){
			let	message = `Your profile has been updated!, to find a specialist, please click the button below.`;
			let action = {
				text: "Now meet a Specialist.",
				action: () => {
					window.open("https://econsult.24telemed.org/search")
				}
			}
			setProfileMessage({ ...profileMessage, action, message });
		}
		else{
			let	message = props?.onUpdated?.message || `Your profile has been updated!, to go to your dashboard, please click the button below.`;
			let action = {
				text: props?.onUpdated?.btnText || "Go to Dashboard.",
				action: () =>  {
					if ( props?.onUpdated?.action)  props?.onUpdated?.action()
					else window.open("https://econsult.24telemed.org/dashboard/")
				}
			}
			setProfileMessage({ ...profileMessage, action, message });
		}
	}, [])
    
    return (
        <Layout sidePanel={true} title={"Account Profile"}>
			{view === 1 ? (
				<InfoActionPage {...profileMessage} />
			): (
				<SettingsLayout
					title={PROFILE?.name}
					data={DATA}
					comms={{}}
					successCallback={()=>setView(1)}
					endPoint={`users/${PROFILE?.username}/`}
					type='profile'
					profileMessage={profileMessage} 
					disableSaving={_.isEqual(DATA, OLD_DATA)}
				>
						<div className="form-body p-5" style={{ paddingTop: "0px !important" }}>
						{/*Fieldset*/}
						<div className="form-fieldset">
								<div className="columns is-multiline">
									
								<div className="column is-12">
									
										<ValidatedInputField
											label={"Username"}
											value={PROFILE?.username}
											callback={e => updateProfile({username: e})}
											endpoint={"/users/checkuser/"}
											icon={getIcon("at-sign")}
											readOnly={props?.readOnly}
										/>
								</div>

								<FormContent {...props} structure={structure} updateProfile={updateProfile} PROFILE={PROFILE} />
								</div>
							</div>
						
						
						
					</div>
				</SettingsLayout>
			)}
        </Layout>
    )
}

const mapStateToProps = ({ user }) => {
	return { user };
};

const mapDispatchToProps = (dispatch) => {
	return {
		// updateSettings: (e) => dispatch(updateSettings(e)),
		closePanel: (e) => dispatch(closePanel(e)),
		openPanel: (e) => dispatch(openPanel(e)),
		
	};
};

export const defaultMsg = {
	title: "Profile has been updated",
	// message: `Your profile has been updated!, to find a specialist, please click the button below.`,
	image: require("../../assets/images/undraw_order_confirmed_re_g0if.svg").default,
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountProfile);